import { Chip } from "@mui/material";

type ThemeVariant = "primary" | "secondary" | "error" | "warning" | "info" | "success" | "default";

const statusToTheme: Record<string, ThemeVariant> = {
  'recebido com sucesso': 'success',
  'aguardando chegada': 'warning',
  'aguardando aprovação fiscal': 'info',
  'análise de divergência': 'error',
};

export interface StatusProps {
  status: string;
  theme?: ThemeVariant;
}

export function Status({ status, theme }: StatusProps) {
  const normalizedStatus = status.toLowerCase().trim();
  const selectedTheme = theme || statusToTheme[normalizedStatus] || 'default';

  return <Chip label={status} color={selectedTheme} variant="outlined" />;
}